module.exports = __webpack_public_path__ + "img/homepage-ads.ccbd7881.jpg";